"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "13",
  r: "1.25"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M17.5 10c.75 0 1.47-.09 2.17-.24.21.71.33 1.46.33 2.24 0 1.22-.28 2.37-.77 3.4l1.49 1.49C21.53 15.44 22 13.78 22 12c0-5.52-4.48-10-10-10-1.78 0-3.44.47-4.89 1.28l5.33 5.33c1.49.88 3.21 1.39 5.06 1.39M2.6 4.43l1.48 1.48C2.51 7.95 1.7 10.6 2.1 13.46c.62 4.33 4.11 7.82 8.44 8.44 2.85.41 5.51-.41 7.55-1.98l1.48 1.48c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L4.01 3.01a.996.996 0 0 0-1.41 0c-.39.4-.39 1.03 0 1.42m14.06 14.06C15.35 19.44 13.74 20 12 20c-4.41 0-8-3.59-8-8 0-.05.01-.1 0-.14 1.39-.52 2.63-1.35 3.64-2.39z"
}, "1")], 'FaceRetouchingOffRounded');